import AkeIcon from './src/Icon.vue'
import SvgIcon from './src/SvgIcon.vue'

export { AkeIcon, SvgIcon }

export default AkeIcon
